import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ContactAttributeDefinitionRequest,
  ContactAttributeDefinitionResponse,
  PageResponse
} from '../models/contact-attribute-definition.model';

@Injectable({
  providedIn: 'root'
})
export class ContactAttributeDefinitionApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/contact-attribute-definitions?businessId=&page=&size= (paginado desde v1.16)
  getDefinitions(businessId: number, page = 0, size = 100): Observable<ContactAttributeDefinitionResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<ContactAttributeDefinitionResponse>>(
      `${this.apiUrl}/contact-attribute-definitions`, { params }
    ).pipe(map(res => res.content));
  }

  // GET /api/contact-attribute-definitions/{id}
  getDefinitionById(id: number): Observable<ContactAttributeDefinitionResponse> {
    return this.http.get<ContactAttributeDefinitionResponse>(`${this.apiUrl}/contact-attribute-definitions/${id}`);
  }

  // POST /api/contact-attribute-definitions
  createDefinition(definition: ContactAttributeDefinitionRequest): Observable<ContactAttributeDefinitionResponse> {
    return this.http.post<ContactAttributeDefinitionResponse>(`${this.apiUrl}/contact-attribute-definitions`, definition);
  }

  // PUT /api/contact-attribute-definitions/{id}
  updateDefinition(id: number, definition: ContactAttributeDefinitionRequest): Observable<ContactAttributeDefinitionResponse> {
    return this.http.put<ContactAttributeDefinitionResponse>(`${this.apiUrl}/contact-attribute-definitions/${id}`, definition);
  }

  // DELETE /api/contact-attribute-definitions/{id}
  deleteDefinition(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/contact-attribute-definitions/${id}`);
  }
}
